import { useIntl } from 'react-intl';

import type { Rarity } from '#src/__generated__/globalTypes.ts';
import { scarcityNames } from '#src/lib/cards.ts';
import { glossary } from '#src/lib/glossary.ts';

type Props = { quantity?: number; rewardName: string };
const RewardCount = ({ quantity = 1, rewardName }: Props) => {
  return `${quantity}× ${rewardName}`;
};

export const EssenceRewardCount = ({
  quantity = 1,
  rarity,
}: {
  quantity?: number;
  rarity?: Rarity;
}) => {
  const { formatMessage } = useIntl();
  return (
    <RewardCount
      quantity={quantity}
      rewardName={
        rarity
          ? formatMessage(glossary.essenceRarityLabel, {
              quantity,
              rarity: scarcityNames[rarity],
            })
          : formatMessage(glossary.essenceLabel, { quantity })
      }
    />
  );
};
